import React, {useEffect, useState} from 'react';
import PageButton from '../../elements/PageButton/PageButton';
import {ChestRewardsList} from '../ChestPurchaseModal/ChestPurchaseModal';
import {MATCH_REWARD_CHEST_CONFIGS, SHOP_CHEST_CONFIGS, TUTORIAL_CHEST_CONFIGS} from '../../../configs/chests';
import {getChestIconPath} from '../../../utils/inventory/getChestIconPath';
import {getChestDisplayName} from '../../../utils/inventory/getChestDisplayName';
import {MENU_SOUND_MANAGER} from '../../../scenes/MenuSoundManager';
import {WIN_POINTS_COLOR_LIGHT} from '../../../styles/constants';
import '../ChestPurchaseModal/ChestPurchaseModal.css';

const PAGE_ID = 'ChestContentsModal';

const ALL_CHEST_CONFIGS = [...MATCH_REWARD_CHEST_CONFIGS, ...SHOP_CHEST_CONFIGS, ...TUTORIAL_CHEST_CONFIGS];

/**
 * Что может выпасть из сундука и с какой вероятностью — без покупки. Оформлена
 * как модалка покупки в магазине (ChestPurchaseModal): та же картинка, имя и
 * таблица наград из конфига, по которому сундук открывает сервер. Нужна там,
 * где сундук получают не покупкой, — в наградах рейтингового матча.
 */
function ChestContentsModal({chestId, onClose}) {
  const [visible, setVisible] = useState(false);
  const chest = ALL_CHEST_CONFIGS.find((config) => config.id === chestId);

  useEffect(() => {
    MENU_SOUND_MANAGER.playChestOpen();
    const showTimer = setTimeout(() => setVisible(true), 50);
    return () => clearTimeout(showTimer);
  }, []);

  const handleClose = () => {
    setVisible(false);
    setTimeout(() => onClose?.(), 300);
  };

  const handleOverlayClick = (event) => {
    if (event.target === event.currentTarget) {
      handleClose();
    }
  };

  if (!chest) return null;

  const name = chest.name || getChestDisplayName(chest.id);

  return (
    <div
      className={`chest-purchase-overlay ${visible ? 'chest-purchase-overlay_visible' : ''}`}
      onClick={handleOverlayClick}
      role="dialog"
      aria-modal="true"
      aria-label={name}
      style={{'--chest-shadow-color': chest.shadowColor ?? WIN_POINTS_COLOR_LIGHT}}
    >
      <div className={`chest-purchase-modal ${visible ? 'chest-purchase-modal_visible' : ''}`}>
        <div className="chest-purchase-content">
          <div className="chest-purchase-image-wrapper">
            <img className="chest-purchase-image" src={getChestIconPath(chest.id)} alt={name}/>
          </div>

          <h2 className="chest-purchase-name" style={{color: chest.modalTextColor || chest.textColor}}>
            {name}
          </h2>

          <div className="chest-purchase-rewards">
            <ChestRewardsList rewards={chest.rewards}/>
          </div>

          <div className="main-menu-buttons chest-purchase-buttons">
            <PageButton className="main-menu-button_secondary" onClick={handleClose} pageId={PAGE_ID} buttonId="close">
              Закрыть
            </PageButton>
          </div>
        </div>
      </div>
    </div>
  );
}

export default ChestContentsModal;
